import $ from 'gridstrap/lib/gs-zepto';
import analytics from 'gridstrap/lib/gs-analytics';

export class GSButton {

	//
	// Properties
	//

	private root;

	get isProcessing()      { return this.root.hasClass('is-processing'); }
	get isSuccess()         { return this.root.hasClass('is-success'); }
	get isVisible()         { return !this.root.hasClass('d-none'); }

	set isProcessing(value) { this.root.toggleClass('is-processing', value); }
	set isSuccess(value)    { this.root.toggleClass('is-success', !!value); }
	set isVisible(value)    { this.root.toggleClass('d-none', !value); }

	get gaCategory() { return this.root.data('gsButtonGaCategory'); }
	get gaLabel()    { return this.root.data('gsButtonGaLabel'); }
	get gaActions()  { return (this.root.data('gsButtonGaActions') || '').split(' '); }

	//
	// Methods
	//

	track(eventAction) {
		if (!this.gaActions.includes(eventAction)) return;
		let { gaCategory: eventCategory, gaLabel: eventLabel } = this;
		analytics.event({ eventCategory, eventAction, eventLabel });
	}

	click() {
		this.track('click');
	}

	//
	// Initializations & Event Listeners
	//

	constructor(root) {
		this.root = $(root);
		this.root
			.filter('[title~="Javascript"]')
			.removeAttr('title')
			.on('click', () => this.click());
	}
}
